import { useStore } from "@/store";
import { Features } from "@/types/features";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as LogoSvg } from "./_assets/logo.svg";
import { NavigationMenu } from "./_dependencies";

export const MainMenuBlock: FunctionComponent = observer((): ReactElement => {
  const store = useStore();

  return (
    <>
      <div className="mainMenuBlock">
        <div>
          <div className="mainMenuBlockHeader">
            <Link to="/">
              <LogoSvg />
            </Link>
            {false && (
              <input type="checkbox" className="toggle-button switchDesc" />
            )}
          </div>
          <NavigationMenu />
        </div>
        <div>
          {false && (
            <ul className="btnGroupVertical">
              <li className="btnGroupVerticalLi">
                <a
                  className="mainBtn"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={store.popup.togglePromote}
                >
                  Приложение
                </a>
              </li>
              {!store.profile.pro &&
                store.profile.isFeatureEnabled([Features.Pro.Purchase]) && (
                  <li className="btnGroupVerticalLi">
                    <a
                      className="secondBtn"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={store.popup.togglePro}
                    >
                      Подписаться
                    </a>
                  </li>
                )}
            </ul>
          )}
        </div>
      </div>
    </>
  );
});
